import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const AccountsListTable = ({
  children,
  count,
  company, ///////
  subcompany, ////////
  permissions, //////z
  handleToggle = () => {}, ///////
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => {
  const headers = [
    { variable: 'key', text: t('accounts.fields.key') + ': ', type: 'h3' },
    { variable: 'name', text: t('accounts.fields.name') + ': ' },
    { variable: 'description', text: t('accounts.fields.description') + ': ' },
    {
      variable: 'active',
      text: t('accounts.fields.active') + ': ',
      boolean: true,
    },
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.accounts.update',
    togglePermission: 'acl.accounts.toggle',
    editUrl: 'accounts', //Url para editar empleado
    propsName: 'account', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };
  return (
    <Common.List dataCard={dataCard}>
      <thead>
        <tr>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="key"
            handleOrderChange={handleOrderChange}
          >
            {t('accounts.fields.key')}
          </Common.ThSortable>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('accounts.fields.name')}
          </Common.ThSortable>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="description"
            handleOrderChange={handleOrderChange}
          >
            {t('accounts.fields.description')}
          </Common.ThSortable>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="active"
            handleOrderChange={handleOrderChange}
            className="text-center"
          >
            {t('accounts.fields.active')}
          </Common.ThSortable>
          <th className="text-center">{t('common.actions')}</th>
        </tr>
      </thead>

      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={10} />}
        {children}
      </tbody>
    </Common.List>
  );
};

export default translate()(AccountsListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/components/list/AccountsListTable.js